import React from 'react';
import { View, StyleSheet } from 'react-native';
import Colors from '../constants/Colors';

export default function ListSeparator(){
  return (
    <View style={styles.listSeparator} />
  );
}

const styles = StyleSheet.create({
  listSeparator: {
    marginVertical: 15,
    borderStyle: 'solid',
    borderTopWidth: 1,
    borderColor: Colors.lightBlue,
  }
})
